export const pageMeta = {
  title: '数字干部管理系统',
  badge: 'AI赋能干部管理',
  description:
    '面向组织部门的一站式干部数字化管理平台，覆盖干部信息管理、选拔任用、考核评价、培养培训、监督预警全流程，以AI驱动组织人事管理提质增效。',
  stats: [
    { value: '5年', label: '干部系统建设经验', icon: '📅' },
    { value: '国产信创', label: '全适配', icon: '🛡️', compact: true },
    { value: '10+', label: '组织部选用', icon: '🏛️' }
  ]
}

export const capabilities = [
  {
    id: 'data-center',
    title: '干部全域数据中心',
    summary: '构建覆盖干部全生命周期的统一数据管理平台，打通基本信息、扩展档案、标签画像、教育培训、监督管理等多维数据壁垒，实现一数一源、全域共享、智能分析。',
    features: [
      { title: '全量数据汇聚', desc: '基本信息、家庭成员、学历学位、职务职级、奖惩记录等百余字段全覆盖' },
      { title: '智能标签管理', desc: '基于履历与考核数据自动生成能力标签、经历标签、预警标签' },
      { title: '干部培训管理', desc: '培训班次管理、培训成绩记录、学时学分统计、在线学习跟踪，构建完整的干部教育培训档案' },
      { title: '干部监督管理', desc: '干部惩处情况追踪、出入境记录管理、护照持有与使用监管、兼职经商行为预警，实现全方位监督覆盖' },
      { title: '关系图谱分析', desc: '干部直系旁系亲属管理、亲属经商办企排查、校友同事关系网络，多维度数据交叉分析' }
    ],
    tags: ['全域数据', '一数一源', '监督管理', '关系图谱', '智能分析']
  },
  
  {
    id: 'portrait',
    title: '干部画像系统',
    summary: '运用大数据分析与可视化技术，构建干部360度全景画像，从政治素质、能力水平、工作实绩、廉洁自律等维度全面刻画干部特征，为选拔、培养、使用提供精准数据支撑。',
    features: [
      { title: '360度全景画像', desc: '多维度综合评估，全面刻画干部政治素质、能力水平与工作实绩' },
      { title: '能力雷达分析', desc: '自动生成能力雷达图，直观展示干部能力分布与优势短板' },
      { title: '数据智能提取', desc: '从干部任免表、考核表等业务文档中自动识别并提取关键字段，智能填充档案信息，大幅减少人工录入工作量' },
      { title: '干部AI画像', desc: '基于多维数据自动生成干部能力雷达图、发展趋势画像，智能推荐人岗匹配方案，辅助科学决策' },
      { title: '人才盘点看板', desc: '组织级人才全景视图，辅助人才盘点与干部梯队规划' }
    ],
    tags: ['全景画像', '雷达分析', '智能提取', 'AI画像', '人才盘点']
  },
  {
    id: 'ai',
    title: 'AI智能赋能',
    summary: '深度融合大模型、知识图谱、自然语言处理等AI技术，为干部管理各环节注入智能化能力，实现材料自动生成、数据智能提取、考核辅助分析，大幅提升组织人事工作效率。',
    features: [
      { title: '档案信息智能提取', desc: 'OCR与NLP技术自动识别提取档案关键信息，自动填充表单' },
      { title: '智能问答助手', desc: '基于大模型的干部数据自然语言问答，随时获取所需信息' },
      { title: '风险预警分析', desc: 'AI自动识别干部管理中的潜在风险，提前发出预警提示' }
    ],
    tags: ['AI提取', '自然语言', '岗位推荐', '智能考察']
  },
 
  {
    id: 'sandbox',
    title: '任免沙盘模拟',
    summary: '提供可视化的干部任免推演沙盘，输入岗位需求与候选人条件，系统自动进行多轮模拟推演，综合分析班子结构影响，输出最优推荐方案与风险提示。',
    features: [
      { title: '方案多轮推演', desc: '输入岗位与候选人条件，系统自动进行多轮模拟推演比选' },
      { title: '条件自动校验', desc: '智能校验回避关系、任职年限、学历要求等硬性条件' },
      { title: '结构影响分析', desc: '评估每次调整对班子整体结构的影响，确保配备科学合理' },
      { title: '风险智能提示', desc: '自动识别任免方案中的潜在风险点并给出规避建议' },
      { title: '方案优选推荐', desc: '综合多维度评分，输出最优任免方案与详细对比分析报告' }
    ],
    tags: ['模拟推演', '条件校验', '风险提示', '方案优选']
  },
 
  {
    id: 'tablet',
    title: '平板数据分析',
    summary: '专为移动办公场景设计的平板端数据分析工具，支持触控交互、手写标注和离线查看，让领导干部随时随地掌握干部管理动态。',
    features: [
      { title: '移动端适配', desc: '针对iPad/平板深度优化，支持触控操作、手势缩放和手写批注' },
      { title: '数据安全管控', desc: '离线数据加密存储、设备绑定认证、传输链路加密，多层级安全策略保障干部数据万无一失' },
      { title: '可视化报表', desc: '提供柱状图、折线图、雷达图等多种图表类型，支持自定义仪表盘' },
      { title: '掌上干部画像', desc: '平板端实时查看干部全景画像、能力雷达图、关系图谱，领导外出调研时可即时调阅干部信息' }
    ],
    tags: ['移动办公', '数据安全', '掌上画像', '可视化报表']
  },
  {
    id: 'security',
    title: '安全合规体系',
    summary: '构建全方位、多层次的安全防护体系，满足党政机关最严格的信息安全要求，支持国产信创环境适配与私有化部署，保障干部数据全生命周期安全。',
    features: [
      { title: '信创环境适配', desc: '全面支持国产操作系统、数据库、中间件，满足等保测评、分保测评要求' },
      { title: '全链路数据加密', desc: '数据从采集、存储到传输全链路加密，确保数据安全' },
      { title: '操作审计日志', desc: '完整记录所有操作行为，支持审计追溯与合规审查' },
      { title: '角色权限管控', desc: '细粒度的RBAC权限模型，实现数据分级分类访问控制' },
      { title: '容灾恢复保障', desc: '数据自动备份与容灾恢复机制，确保业务连续性与数据安全' }
    ],
    tags: ['等保测评', '信创适配', '操作审计', '容灾恢复']
  }
]

export const whyUs = {
  stats: [
    { value: '8年', label: '专注党政信息化' },
    { value: '500+', label: '组织部门验证' },
    { value: '100%', label: '全自研技术' },
    { value: '50+', label: '核心产品功能' }
  ],
  items: [
    { title: '8年行业深耕', desc: '自2018年起专注党政机关干部管理信息化建设，深度参与多个省级组织人事系统项目，积累了丰富的行业Know-How。' },
    { title: '500+组织部验证', desc: '产品已在全国多省市县组织部门稳定运行，覆盖省、市、县三级组织体系，经受住了真实业务场景的反复检验。' },
    { title: '安全可控·信创适配', desc: '全自研技术栈满足信创环境要求，支持国产操作系统与数据库，私有化部署确保数据不出域，通过等保测评认证。' },
    { title: 'AI技术深度赋能', desc: '自研政务AI大模型与知识图谱引擎，智能画像分析、考核自动赋分、材料智能生成等核心能力在行业内保持领先。' },
    { title: '完整产品矩阵', desc: '覆盖干部管理、任免全流程、考核测评、平板端分析、任免上会五大核心业务场景，实现组织人事一站式闭环管理。' },
    { title: '政策合规先行', desc: '严格对标《党政领导干部选拔任用工作条例》等最新政策法规，确保系统功能与组织工作要求始终保持同步。' }
  ]
}

export const scenarios = [
  {
    label: '基础信息管理',
    title: '干部档案"一人一档"管理',
    desc: '统一采集维护干部任免审批表、家庭成员、学历学位、职务职级等百余字段，建立全量数据库，支持批量导入、自动校验、智能去重，保障干部信息一数一源权威可信。',
    tags: ['一人一档', '数据治理', '智能校验']
  },
  {
    label: '选拔任用辅助',
    title: '干部选拔任用智能辅助',
    desc: '严格遵循《党政领导干部选拔任用工作条例》，依据任职年限、学历专业、基层经历、回避关系等条件智能筛选候选人选，自动校验任职资格与编制职数约束，为五人小组决策提供客观数据支撑。',
    tags: ['条例合规', '回避审查', '方案比选']
  },
  {
    label: '考核评价管理',
    title: '干部考核多维度评价',
    desc: '整合年度考核、平时考核、专项考核与任期考核数据，支持360度民主测评和实绩量化指标填写，AI自动加权计算综合得分并生成考核分析报告，确保评价结果公平公正。',
    tags: ['民主测评', '量化评价', 'AI赋分']
  },
  {
    label: '监督管理',
    title: '干部监督预警体系',
    desc: '涵盖亲属回避提醒、出入境记录异常监控、护照集中管理等场景，自动识别兼职违规、经商办企等风险事项，支持闭环处置与整改跟踪，实现干部监督从被动应对向主动预防转变。',
    tags: ['预警规则', '护照管理', '闭环处置']
  },
  {
    label: 'AI赋能',
    title: '内网AI智能引擎',
    desc: '基于内网私有化部署的大模型，确保数据安全合规。结合AI干部管理机系统，可实现干部档案智能摘要、考核材料自动生成、干部画像多维度智能分析、任职资格自动校验、班子结构优化建议等AI原生能力，让组织工作从"人工经验驱动"升级为"数据+AI驱动"。',
    tags: ['内网私有化', '档案智能摘要', '考核材料自动生成', '智能分析']
  },
  {
    label: '决策辅助看板',
    title: '领导决策数据看板',
    desc: '面向组织部长和分管领导，提供干部队伍全景数据看板，可视化呈现班子年龄梯次、专业结构、来源经历分布等关键维度，支持平板端即时查阅干部画像与班子分析。',
    tags: ['决策看板', '班子分析', '平板查阅']
  }
]

export const architecture = {
  title: '干部管理系统',
  desc: '以干部信息库为核心，兼容多源数据格式导入导出，融合智能提取、搜索与分析能力，支撑任免、监督、培训、考核全流程，并通过领导查询APP实现加密离线查阅。',
  dataSources: {
    title: '日常数据格式兼容',
    items: [
      { type: 'zzb', label: '任免表LRMX' },
      { type: 'word', label: 'Word任免表' },
      { type: 'excel', label: '干部名册' },
      { type: 'ppt', label: 'PPT上会材料' },
      { type: 'text', label: '干部简介描述' }
    ],
    flow: '导入/导出'
  },
  database: {
    title: '干部信息库',
    desc: '可扩展、易维护、信息全面、准确一致'
  },
  aiFeatures: [
    {
      title: '智能提取',
      items: ['任职经历', '公务员职级', '领导职务层次']
    },
    {
      title: '智能搜索',
      items: ['多维度、多轮查询', '交叉统计', '数据透视与反查']
    },
    {
      title: '智能分析',
      items: ['公务员职级晋升', '亲属同事关系图', '干部画像、班子模型']
    }
  ],
  modules: [
    {
      title: '干部任免',
      items: ['岗位配备', '人岗匹配/动议', '推荐/考察', '讨论/决定', '任免']
    },
    {
      title: '干部监督',
      items: ['处分', '影响期', '出入境管理', '个人事项', '综合监督查询']
    },
    {
      title: '干部培训',
      items: ['培训班管理', '需求分析', '培训计划', '记录查询']
    },
    {
      title: '干部考核',
      items: ['平时考核/测评', '年度考核', '结果批量维护', '统计提醒']
    }
  ],
  app: {
    title: '领导查询APP',
    exportLabel: '加密数据离线导出',
    features: [
      { icon: '👥', label: '班子情况一览' },
      { icon: '📋', label: '干部名册' },
      { icon: '⚖️', label: '超配空缺' },
      { icon: '🔍', label: '快捷查询' },
      { icon: '📊', label: '统计与反查' },
      { icon: '📝', label: '对比研判' }
    ]
  },
  footer: '数据安全 · 加密离线 · 等保测评 · 私有化部署'
}

export const cadreClients = [
  '十堰市委组织部', '襄阳市委组织部', '荆州市委组织部', '宜昌市委组织部',
  '恩施州组织部', '黄冈市委组织部', '孝感市委组织部', '随州市组织部',
  '荆门市委组织部', '天门市委组织部', '潜江市委组织部', '仙桃市委组织部',
  '东风汽车集团', '湖北交投集团', '湖北农商银行', '汉口银行',
  '湖北汽车工业学院', '湖北医药学院', '汉江师范学院', '湖北师范大学',
  '武汉音乐学院', '湖北民族大学', '三峡大学', '长江大学'
]

export const newsItems = {
  industry: [
    { date: '2026-06-15', title: '上任一周，用系统+AI把队伍摸清、结构看透、风险看清' },
    { date: '2026-06-12', title: '大模型在政务场景的落地实践：从技术到价值的跨越' },
    { date: '2026-06-17', title: '数字化转型浪潮下，干部管理如何从"经验驱动"迈向"数据驱动"？' }
  ],
  updates: [
    { date: '2026-06-17', title: '小智测评考核系统全新升级：AI智能识别技术让干部民主测评告别"手工计票时代"' },
    { date: '2026-06-17', title: '小智干部管理系统 V5.7 发布：首家把"平板端离线数据 + AI 搜索"做成可落地能力的组工场景方案（深度解析）' }
  ]
}
